import "./NotFound.css";

import { PAGES } from "./constants";
import React from "react";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  const handleHomeButton = () => {
    navigate(PAGES.HOME);
  }

  return (
    <div className="not-found-container">
      <h1 className="not-found-header">404</h1>
      <p className="not-found-paragraph">Oops! The page you're looking for doesn't exist.</p>
      <button className="not-found-button" onClick={handleHomeButton}>Take me back to the homepage</button>
    </div>
  );
};

export default NotFound;